<div class="modal-header" appCustomAutofocus>
    <h3>{{ChecklistModeName}} Workflow</h3>
</div>
<div class="modal-body">
    <div class="row" style="margin-bottom: 12px;">
        <div class="col-lg-12">
            <input type="checkbox" style="width:25px;height:25px;"
                   class="mr-1"
                   [(ngModel)]="templateInfo.EnableWorkflow"
                   (ngModelChange)="workflowEnabled()" /> <b>Enable Workflow For This Template?</b>
        </div>
    </div>
    <div *ngIf="mode !== 'H'">
        <div class="row">
            <div class="col-lg-12">
                <div class="alert alert-info">
                    <input type="checkbox" style="width:25px;height:25px;"
                           class="mr-1"
                           [(ngModel)]="templateInfo.WorkflowInclPM"
                           [disabled]="!templateInfo.EnableWorkflow"
                           (ngModelChange)="updateItem()" /> <b>{{mode === 'S' ? 'Route to Reviewer on the Work Order' : 'Route to PM?'}}</b> <br />
                    {{mode === 'S' ? 'Email the reviewer on the Work Order when the work order trip is closed.' : 'Email the project manager from PM Projects when checklists are submitted.'}}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="alert alert-info">
                    <input type="checkbox" style="width:25px;height:25px;"
                           class="mr-1"
                           [(ngModel)]="templateInfo.WorkflowInclJobRev"
                           [disabled]="!templateInfo.EnableWorkflow"
                           (ngModelChange)="updateItem()" /> <b>{{mode === 'S' ? 'Route to the reviewer on ServiceCenter?' : 'Route to Job Reviewers?'}}</b><br />
                    {{mode === 'S' ? 'Email the reviewer on Service Center when the work order trip is closed.' : 'Email reviewers on JC Jobs when checklists are submitted.'}}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="alert alert-info">
                    <input type="checkbox" style="width:25px;height:25px;"
                           class="mr-1"
                           [(ngModel)]="templateInfo.WorkflowInclInvRev"
                           [disabled]="!templateInfo.EnableWorkflow"
                           (ngModelChange)="updateItem()" /> <b>{{mode === 'S' ? 'Exclude from trip close out' : 'Route to Member of Invoice Rev. Group?'}}</b><br />
                    {{mode === 'S' ? 'This form will not be included in the trip close out package but will save a record to Vista when the work order trip is closed.' : 'Email reviewers on the assigned Invoice Reviewer Group for the job when checklists are submitted.'}}
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="mode === 'H'">
        <div class="col-lg-12">
            <div class="alert alert-info">
                <input type="checkbox" style="width:25px;height:25px;"
                       class="mr-1"
                       [(ngModel)]="templateInfo.WorkflowInclTimecardManager"
                       [disabled]="!templateInfo.EnableWorkflow"
                       (ngModelChange)="updateItem()" /> <b>Route to Manager?</b><br />
                Email the manager assigned to the employee for timecard approval when action items are submitted.
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <div class="alert alert-info">
                <b>User Group to Route To:</b>
                <ng-select [(ngModel)]="templateInfo.WorkflowInclUserGroupID"
                           [disabled]="!templateInfo.EnableWorkflow"
                           (ngModelChange)="userGroupChange()" [clearable]=false
                           [searchable]="false">
                    <ng-option *ngFor="let data of userGroups" [value]="data.UserGroupID">{{data.UserGroupName}}</ng-option>
                </ng-select>
                {{mode === 'S' ? 'Email employees in the above user group when the work order trip is closed.' : mode !== 'H' ? 'Email employees in the above user group when checklists are submitted.' : 'Email employees in the above user group when action items are submitted.'}}
            </div>
        </div>
    </div>
    <div class="row" style="margin-bottom: 12px;" *ngIf="mode === 'H' || mode === 'C'">
        <div class="col-lg-12">
            <div class="alert alert-info">
                <input type="checkbox" style="width:25px;height:25px;"
                       class="mr-1"
                       [(ngModel)]="templateInfo.WorkflowUsersCanFinalize"
                       [disabled]="!templateInfo.EnableWorkflow"
                       (ngModelChange)="updateItem()" /> <b>Enable workflow reviewers to Finalize {{ChecklistModeName}}</b><br />
                Allow any reviewer to Finalize the {{ChecklistModeName}}.
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="saveClicked()">Save</button>
</div>
